{
  "common": {
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "noData": "No data available",
    "yes": "Yes",
    "no": "No",
    "admin": "Admin",
    "user": "User",
    "actions": "Actions",
    "home": "Home",
    "companies": "Companies",
    "create": "Create",
    "details": "Details",
    "import": "Import",
    "settings": "Settings",
    "subscription": "Subscription",
    "member": "Member",
    "users": "Users",
    "integrations": "Integrations",
    "refresh": "Refresh",
    "loadMore": "Load more"
  },
  "companyDetails": {
    "title": "Company Details",
    "overview": {
      "title": "Overview",
      "subtitle": "Key business metrics and information",
      "crmId": "CRM ID",
      "status": "Status",
      "mrr": "MRR",
      "leadSource": "Lead Source",
      "market": "Market",
      "industry": "Industry",
      "activityLevel": "Activity Level",
      "leadStatus": "Lead Status"
    },
    "ownership": {
      "title": "Ownership & People",
      "subtitle": "Team members and ownership details",
      "owner": "Owner",
      "salesRep": "Sales Rep",
      "csmId": "CSM ID"
    },
    "dates": {
      "title": "Dates & Metadata",
      "subtitle": "Important dates and record information",
      "createdDate": "Created Date",
      "recordCreated": "Record Created"
    },
    "customFields": {
      "title": "Custom Fields",
      "subtitle": "Additional custom field information",
      "noFields": "No custom fields defined for this account.",
      "configureLink": "Configure custom fields"
    },
    "history": {
      "title": "Change History",
      "subtitle": "Track all changes and updates to this company",
      "addRecord": "Add Record"
    },
    "actions": {
      "editTooltip": "Edit this company",
      "deleteTooltip": "Delete this company record",
      "deleteConfirmTitle": "Delete Company record?",
      "deleteConfirmDescription": "Are you sure you want to delete this company record?",
      "deleteSuccess": "Company record deleted successfully",
      "deleteSuccessNavigate": "Company record deleted successfully. Navigate back to companies list",
      "deleteError": "Unable to delete company record",
      "fetchError": "Error fetching data"
    },
    "empty": {
      "title": "No company data available",
      "description": "The company information could not be loaded."
    },
    "status": {
      "na": "N/A",
      "lead": "Lead",
      "opportunity": "Opportunity",
      "customer": "Customer"
    }
  },
  "dashboard": {
    "metrics": {
      "totalCompanies": "Total Companies",
      "customers": "Customers",
      "leads": "Leads",
      "churned": "Churned"
    },
    "cards": {
      "companiesStatusDistribution": "Companies Status Distribution",
      "dataSourceAnalytics": "Data Source Analytics",
      "recentCompanies": "Recent Companies",
      "viewAllCompanies": "View All Companies",
      "added": "Added",
      "source": "Source"
    },
    "status": {
      "opportunity": "Opportunity",
      "lead": "Lead",
      "lostLead": "Lost Lead",
      "customer": "Customer",
      "churned": "Churned",
      "lostOpportunity": "Lost Opportunity"
    },
    "dataSource": {
      "hubspot": "HubSpot",
      "importXls": "Excel Import",
      "manual": "Manual Entry",
      "zapier": "Zapier",
      "total": "Total",
      "numberOfCompanies": "Number of Companies",
      "companySourceDistribution": "Company Source Distribution",
      "companiesBySource": "Companies by Source",
      "averageCustomerValueBySource": "Average Customer Value by Source"
    },
    "errors": {
      "loadCompaniesData": "Unable to load companies data",
      "loadRecentCompanies": "Unable to load recent companies"
    },
    "totalCompanies": "Total Companies"
  },
  "companies": {
    "list": {
      "title": "My Companies",
      "total": "Total",
      "searchPlaceholder": "Search companies...",
      "importFile": "Import File",
      "import": "Import",
      "exportXls": "Export XLS",
      "export": "Export",
      "newCompany": "New Company",
      "new": "New",
      "exportCurrentState": "Export current state",
      "exportAll": "Export all",
      "columns": {
        "name": "Name",
        "mrr": "MRR",
        "status": "Status",
        "lastUpdated": "Last Updated"
      },
      "errors": {
        "exportError": "Error exporting XLS file:",
        "limitReached": "Companies limit reached. Please upgrade your plan to import more companies.",
        "exportLimitReached": "Companies limit reached. Only limited companies will be exported. Upgrade your plan to export all companies.",
        "listLimitReached": "Companies limit reached. Only limited companies are visible. Upgrade your plan to see all companies."
      },
      "limitBanner": {
        "title": "Companies Limit Reached",
        "message": "You've reached your plan's limit of {{max}} companies (currently {{current}}). Some functionality may be limited.",
        "upgrade": "Upgrade Plan",
        "upgradeLink": "Upgrade your plan"
      }
    },
    "create": {
      "title": "Create new company record",
      "duplicatedRecord": "Duplicated Record",
      "duplicateInfo": "This form is pre-populated with data from an existing record. Please update the Date Created field to create a new record.",
      "sections": {
        "generalInformation": "General Information",
        "financialStatus": "Financial & Status Information",
        "contactInformation": "Contact Information",
        "marketInformation": "Market Information",
        "activityInformation": "Activity Information",
        "otherInformation": "Other Information",
        "customFields": "Custom Fields"
      },
      "fields": {
        "companyName": "Company Name",
        "crmId": "CRM ID",
        "companyOwner": "Company Owner",
        "mrr": "MRR",
        "companyStatus": "Company Status",
        "leadStatus": "Lead Status",
        "customerSuccessManagerId": "Customer Success Manager ID",
        "organizationNumber": "Organization Number",
        "salesRepresentative": "Sales Representative",
        "market": "Market",
        "industry": "Industry",
        "leadSource": "Lead Source",
        "activityLevel": "Activity Level",
        "companyActive": "Company Active?",
        "dateCreated": "Date Created"
      },
      "statusOptions": {
        "lead": "Lead",
        "lostLead": "Lost Lead",
        "opportunity": "Opportunity",
        "customer": "Customer",
        "churnedCustomer": "Churned Customer",
        "lostOpportunity": "Lost Opportunity"
      },
      "leadStatusOptions": {
        "open": "Open",
        "lost": "Lost",
        "won": "Won"
      },
      "customFieldsHelper": "Max 255 chars. Empty string keeps blank value.",
      "loadingCustomFields": "Loading custom fields...",
      "duplicateWarning": "Important: Change the Date Created to create a new record. Records with the same date may not be allowed.",
      "actions": {
        "cancel": "Cancel",
        "createRecord": "Create Record"
      },
      "errors": {
        "loadCustomFields": "Failed to load custom fields",
        "createError": "Failed to create company",
        "createSuccess": "Company created successfully"
      },
      "validation": {
        "companyNameRequired": "Company name is required",
        "companyNameMin": "Company name must be at least 3 characters",
        "mrrRequired": "MRR is required",
        "mrrMin": "MRR should be 0 or positive",
        "crmIdRequired": "CRM ID is required",
        "crmIdMin": "CRM ID must be at least 1 character",
        "statusRequired": "Status is required",
        "statusInvalid": "Invalid status",
        "leadStatusRequired": "Lead status is required",
        "leadStatusInvalid": "Invalid lead status",
        "dateCreatedRequired": "Date Created is required",
        "errorsSummary": "Please fix the following errors:"
      }
    },
    "edit": {
      "title": "Update Company",
      "updateTitle": "Update company record",
      "sections": {
        "generalInformation": "General Information",
        "financialStatus": "Financial & Status Information",
        "contactInformation": "Contact Information",
        "marketInformation": "Market Information",
        "activityInformation": "Activity Information",
        "otherInformation": "Other Information",
        "customFields": "Custom Fields"
      },
      "fields": {
        "companyName": "Company Name",
        "crmId": "CRM ID",
        "companyOwner": "Company Owner",
        "mrr": "MRR",
        "companyStatus": "Company Status",
        "leadStatus": "Lead Status",
        "customerSuccessManagerId": "Customer Success Manager ID",
        "organizationNumber": "Organization Number",
        "salesRepresentative": "Sales Representative",
        "market": "Market",
        "industry": "Industry",
        "leadSource": "Lead Source",
        "activityLevel": "Activity Level",
        "companyActive": "Company Active?",
        "dateCreated": "Date Created"
      },
      "statusOptions": {
        "lead": "Lead",
        "lostLead": "Lost Lead",
        "opportunity": "Opportunity",
        "customer": "Customer",
        "churnedCustomer": "Churned Customer",
        "lostOpportunity": "Lost Opportunity"
      },
      "leadStatusOptions": {
        "open": "Open",
        "lost": "Lost",
        "won": "Won"
      },
      "customFieldsHelper": "Max 255 chars. Empty string keeps blank value.",
      "loadingCustomFields": "Loading custom fields...",
      "actions": {
        "cancel": "Cancel",
        "updateRecord": "Update Record"
      },
      "validation": {
        "errorsSummary": "Please fix the following errors:"
      },
      "errors": {
        "loadCustomFields": "Failed to load custom fields",
        "loadCustomFieldValues": "Failed to load custom field values",
        "updateError": "Failed to update company.",
        "updateSuccess": "Company updated successfully",
        "fetchError": "Error fetching data"
      }
    },
    "import": {
      "title": "Import Companies",
      "selectExcelFile": "Select Excel file",
      "downloadTemplate": "Download template",
      "dragDropText": "Drag & drop your Excel (.xlsx or .xls) file here",
      "clickToBrowse": "or click to browse",
      "selectedFile": "Selected file:",
      "fileInfo": "Make sure your columns match the template. Only .xlsx or .xls files up to 10MB are supported.",
      "fileDetails": {
        "size": "Size",
        "type": "Type",
        "lastModified": "Last modified"
      },
      "actions": {
        "importFile": "Import file",
        "importing": "Importing…",
        "importingProgress": "Importing… {{progress}}%",
        "replaceFile": "Replace file",
        "remove": "Remove"
      },
      "results": {
        "title": "Import results",
        "rowsInDuration": "{{count}} rows in {{duration}}s",
        "success": "Success",
        "errors": "Errors",
        "clearResults": "Clear results",
        "all": "All ({{count}})",
        "successCount": "Success ({{count}})",
        "errorCount": "Errors ({{count}})",
        "tableHeaders": {
          "rowId": "Row ID",
          "name": "Name",
          "crmId": "CRM ID",
          "result": "Result",
          "errors": "Errors"
        },
        "importError": "Import Error"
      },
      "errors": {
        "noFileSelected": "Please choose a file to upload.",
        "fileRequired": "Please select a file.",
        "invalidExtension": "Only .xlsx or .xls files are supported.",
        "fileTooLarge": "File is too large (max 10MB).",
        "importSuccess": "Companies imported successfully",
        "importFailed": "Failed to import XLS file",
        "limitReached": "Companies limit reached. Please upgrade your plan to import more companies."
      }
    }
  },
  "menu": {
    "dashboard": {
      "title": "Menu",
      "items": {
        "default": "Dashboard",
        "feed": "Feed",
        "companies": "Companies"
      }
    },
    "settings": {
      "title": "Settings",
      "items": {
        "settings": "Settings",
        "team": "My Team",
        "customFields": "Custom Fields",
        "subscription": "My Subscription",
        "billing": "Billing",
        "plan": "Plan",
        "crmIntegrations": "CRM Integrations",
        "overview": "Overview",
        "hubspot": "Hubspot CRM",
        "zapier": "Zapier"
      }
    }
  },
  "aiChat": {
    "title": "AI Assistant",
    "startNewChat": "Start New Chat",
    "empty": "Start a conversation by sending a message",
    "typing": "AI is typing...",
    "composerPlaceholder": "Type your message...",
    "examples": {
      "heading": "How can I help you today?",
      "subheading": "Try one of these examples to get started",
      "companyOperations": "Company Operations",
      "teamOperations": "Team Operations",
      "userOperations": "User Operations",
      "createCompany": "Create a company called Acme Corp",
      "renameCompany": "Rename company to New Name",
      "renameTeam": "Rename team to Acme Corp",
      "changeTeamName": "Change team name to New Name",
      "inviteAdmin": "Invite john@example.com to the team as an admin",
      "inviteUser": "Invite user@example.com with user role"
    },
    "tool": {
      "inviteUser": "Invite User:",
      "email": "Email:",
      "role": "Role:",
      "adminsOnly": "Note: Only team admins can invite users",
      "renameTeam": "Rename Team:",
      "renameCompany": "Rename Company:",
      "newTeamName": "New team name: {{name}}",
      "details": "Details:",
      "userInvited": "User {{email}} has been invited to the team with role: {{role}}",
      "teamRenamed": "Team renamed to \"{{name}}\" successfully",
      "companyRenamed": "Company renamed to \"{{name}}\" successfully",
      "viewCompany": "View Company",
      "success": "Tool executed successfully",
      "approve": "Approve",
      "deny": "Deny"
    }
  },
  "breadcrumbs": {
    "importXlsx": "Import XLSX File",
    "trash": "Trash",
    "spam": "Spam",
    "drafts": "Drafts",
    "paymentSuccess": "Payment Success",
    "paymentError": "Payment Error",
    "customFields": "Custom Fields",
    "updateCompany": "Update Company"
  },
  "notifications": {
    "title": "Notifications",
    "all": "All Notifications",
    "emptyTitle": "No notifications yet",
    "emptyDescription": "When you have notifications, they'll appear here",
    "loading": "Loading...",
    "noMore": "No more notifications",
    "dismiss": "Dismiss",
    "read": "Read",
    "new": "New",
    "unknownTime": "Unknown time",
    "viewAll": "View All Notifications",
    "ariaLabel": "Notification: {{message}}"
  },
  "layout": {
    "theme": {
      "toggle": "Toggle color theme"
    },
    "footer": {
      "version": "Metafor · v"
    },
    "profile": {
      "hello": "Hello,",
      "team": "Team {{role}}",
      "profileSettings": "Profile settings",
      "logout": "Logout",
      "teamSelection": "Team Selection",
      "selectTeam": "Select team",
      "yourTeams": "Your Teams"
    },
    "upgradeCard": {
      "upgradeTitle": "Upgrade your plan",
      "unlock": "Unlock premium features:",
      "unlimitedIntegrations": "Unlimited integrations",
      "moreUsersCompanies": "More users & companies",
      "advancedFeatures": "Advanced features",
      "goPremium": "Go Premium",
      "premiumActive": "Premium Plan Active",
      "activeUntil": "Active until",
      "premiumAccess": "Your plan will renew automatically. <br /> You have access to all premium features.",
      "manageSubscription": "Manage Subscription"
    },
    "sidebar": {
      "myPlan": "My Plan",
      "goToSubscription": "Go to My Subscription",
      "menuItemsError": "Menu Items Error",
      "mailboxFolders": "mailbox folders"
    },
    "header": {
      "openCityView": "Open City View"
    }
  },
  "auth": {
    "brandHeadline": "Spreadsheets don't motivate. Metaphors do.",
    "brandSubtitle": "Visualize your business — every building a customer, every skyline a story.",
    "welcomeBack": "Welcome back",
    "enterCredentials": "Enter your credentials to continue",
    "noAccount": "Don't have an account?",
    "alreadyHaveAccount": "Already have an account?",
    "signInWithGoogle": "Sign in with Google",
    "signUpWithGoogle": "Sign up with Google",
    "or": "OR",
    "signInWithEmail": "Sign in with Email address",
    "signUpWithEmail": "Sign up with Email address",
    "emailAddress": "Email Address",
    "emailUsername": "Email Address / Username",
    "password": "Password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot Password?",
    "signIn": "Sign in",
    "signUp": "Sign up",
    "firstName": "First Name",
    "lastName": "Last Name",
    "agreeWith": "Agree with",
    "terms": "Terms & Condition.",
    "togglePassword": "toggle password visibility",
    "loginSuccess": "Login Success",
    "invalidCredentials": "Wrong username or password",
    "registerSuccess": "User was registered successfully. Please check your email to activate the account",
    "registerError": "Unable to register user",
    "validation": {
      "validEmail": "Must be a valid email",
      "emailRequired": "Email is required",
      "passwordRequired": "Password is required",
      "firstNameMin": "First name must be at least 2 characters",
      "firstNameRequired": "First name is required",
      "lastNameMin": "Last name must be at least 2 characters",
      "lastNameRequired": "Last name is required"
    },
    "resetPassword": {
      "title": "Reset Password",
      "subtitle": "Enter your email address to receive a password reset link",
      "send": "Send Reset Email",
      "sentMessage": "If an account with that email exists, you will receive a password reset email shortly.",
      "backToLogin": "Back to Login",
      "requestSent": "Password reset request sent",
      "requestError": "Error sending password reset request",
      "setTitle": "Set New Password",
      "setSubtitle": "Enter your new password below",
      "setSuccess": "Your password has been set. You can now log in with your new password.",
      "backToLoginLower": "Back to login",
      "newPassword": "New Password",
      "confirmPassword": "Confirm Password",
      "setPassword": "Set Password",
      "passwordMin": "Password must be at least 8 characters",
      "passwordsMatch": "Passwords must match",
      "confirmRequired": "Confirm Password is required",
      "invalidToken": "Invalid or missing token.",
      "setSuccessToast": "Password has been set successfully",
      "setError": "Error setting new password"
    },
    "verification": {
      "verifiedToast": "Email verified successfully!",
      "failedToast": "Email verification failed. Please try again.",
      "resendSuccess": "Verification email sent successfully",
      "resendError": "Failed to send verification email. Please try again later.",
      "successTitle": "Email Verified!",
      "successSubtitle": "Your email address has been successfully verified",
      "redirecting": "Redirecting to dashboard in {{count}} seconds...",
      "goDashboardNow": "Go to Dashboard Now",
      "verifyingTitle": "Verifying Email",
      "verifyingText": "Please wait while we verify your email address...",
      "title": "Email Verification",
      "checkInbox": "Check your inbox",
      "instructions": "We've sent a verification link to your email address. Please check your inbox and click the link to activate your account.",
      "sent": "Verification email sent",
      "resendIn": "Resend in {{count}} seconds",
      "resend": "Resend Verification Email",
      "helpText": "You can request another verification email after the countdown. Please check your spam folder if you don't see the email in your inbox."
    }
  },
  "feed": {
    "title": "Activity Feed",
    "empty": "No activity to display yet.",
    "viewCompany": "View company"
  },
  "upgrade": {
    "title": "A Premium feature",
    "description": "This feature is available on the Premium plan. Upgrade to unlock integrations, custom fields and higher limits.",
    "button": "Upgrade to Premium",
    "dashboard": "Go to dashboard"
  },
  "v2": {
    "language": "Language",
    "nav": {
      "workspace": "Workspace",
      "administration": "Administration",
      "citySettings": "City settings",
      "mcp": "MCP access",
      "ai": "AI model",
      "premium": "Premium feature",
      "slack": "Slack"
    },
    "theme": {
      "appearance": "Appearance",
      "light": "Light",
      "dark": "Dark",
      "system": "Match system"
    },
    "team": {
      "yourTeams": "Your teams",
      "switchFailed": "Couldn't switch team. Try again.",
      "title": "Team",
      "subtitle": "Name, formats and the people on this team.",
      "generalTitle": "General",
      "generalHint": "Everyone on the team sees these.",
      "name": "Team name",
      "nameRequired": "Enter a team name.",
      "dateFormat": "Date and time format",
      "dateFormatHint": "Used for every date in the app.",
      "currency": "Currency",
      "currencyHint": "Used for MRR everywhere.",
      "save": "Save changes",
      "saved": "Team settings saved",
      "saveFailed": "Team settings weren't saved. Try again.",
      "membersTitle": "Members",
      "rolesHint": "Invited people get an email with a link to join.",
      "adminRole": "can change settings, edit and import companies, and connect CRMs.",
      "userRole": "can browse companies, the feed and City View.",
      "seats": "{{used}} of {{total}} seats used",
      "seatsFull": "All seats are taken. Upgrade the plan to invite more people.",
      "invite": "Invite",
      "member": "Member",
      "role": "Role",
      "you": "you",
      "remove": "Remove",
      "removeNamed": "Remove {{email}}",
      "removeTitle": "Remove from team?",
      "removeBody": "{{email}} loses access to this team straight away.",
      "removed": "{{email}} removed",
      "removeFailed": "Couldn't remove this member. Try again.",
      "inviteTitle": "Invite a member",
      "inviteBody": "They'll get an email with a link to join this team.",
      "roleUserOption": "User: view only",
      "roleAdminOption": "Admin: full access",
      "sendInvite": "Send invite",
      "invited": "Invite sent to {{email}}",
      "inviteFailed": "Invite wasn't sent. Try again.",
      "planTitle": "Plan",
      "planHint": "Limits, usage and billing live on the subscription page.",
      "openSubscription": "Open subscription",
      "dangerTitle": "Danger zone",
      "dangerHint": "These can't be undone.",
      "wipeTitle": "Delete all team data",
      "wipeBody": "Removes every company and every member from this team.",
      "wipeAction": "Delete all data",
      "wipeConfirmTitle": "Delete all team data?",
      "wipeConfirmBody": "Every company, its history and every member of this team will be deleted. This can't be undone.",
      "wipeType": "Type {{name}} to confirm",
      "wiped": "All team data deleted",
      "wipeFailed": "Team data wasn't deleted. Try again.",
      "roleChanged": "{{email}} is now {{role}}",
      "roleFailed": "Role wasn't changed. Try again.",
      "roleFor": "Role for {{email}}",
      "planIncludes": "Included in the plan",
      "features": {
        "xls_import": "Excel import",
        "crm_integrations": "CRM integrations (HubSpot, Zapier)",
        "custom_fields": "Custom fields",
        "advanced_analytics": "Advanced analytics",
        "api_access": "API access",
        "priority_support": "Priority support"
      }
    },
    "plan": {
      "manage": "Manage plan"
    },
    "notifications": {
      "viewAll": "See all notifications"
    },
    "dashboard": {
      "summary_one": "{{total}} company from {{sources}} sources",
      "summary_other": "{{total}} companies from {{sources}} sources",
      "emptySummary": "No companies yet",
      "skylineTitle": "Companies by status",
      "skylineHint": "One building per status. Taller means more companies.",
      "emptyTitle": "Your city is empty",
      "emptyBody": "Import a spreadsheet or connect HubSpot, and each status will rise here as a building.",
      "importCta": "Import companies",
      "connectCta": "Connect a CRM",
      "recentTitle": "Recently added",
      "viewAll": "View all companies",
      "noRecent": "Companies you add will show up here.",
      "sourcesTitle": "Where companies come from"
    },
    "auth": {
      "signInTitle": "Sign in to Metafor",
      "continueWithGoogle": "Continue with Google",
      "orEmail": "or with email",
      "email": "Email",
      "forgotPassword": "Forgot password?",
      "signingIn": "Signing in…",
      "wrongCredentials": "That email and password don't match. Check both and try again.",
      "googleFailed": "Google sign-in didn't complete. Try again.",
      "newHere": "New to Metafor?",
      "createAccount": "Create account",
      "registerTitle": "Create your account",
      "registerSubtitle": "Your team's companies, drawn as a city.",
      "firstName": "First name",
      "lastName": "Last name",
      "passwordMin6": "Use at least 6 characters",
      "haveAccount": "Already have an account?",
      "resetTitle": "Reset your password",
      "sendResetLink": "Send reset link",
      "setPasswordTitle": "Choose a new password",
      "newPassword": "New password",
      "confirmPassword": "Repeat new password",
      "savePassword": "Save password",
      "invalidLink": "This link is missing its reset code. Open the link from the email again, or request a new one.",
      "checkSpam": "Nothing after a few minutes? Check your spam folder.",
      "wrongAccount": "Not you?",
      "signInOther": "Sign in with another account",
      "strength": {
        "poor": "Poor",
        "weak": "Weak",
        "fair": "Fair",
        "good": "Good",
        "strong": "Strong"
      }
    },
    "companies": {
      "count_one": "{{total}} company",
      "count_other": "{{total}} companies",
      "searchPlaceholder": "Search by name or CRM ID",
      "clearSearch": "Clear search",
      "filterByStatus": "Filter by status",
      "clearFilters": "Clear",
      "clearAll": "Clear search and filters",
      "noMatches": "No companies match this search and filter.",
      "emptyTitle": "No companies yet",
      "emptyBody": "Import a spreadsheet, connect a CRM, or add a company by hand.",
      "exportFiltered": "Export this view",
      "exportAll": "Export all companies",
      "exportFailed": "Export didn't finish. Try again.",
      "loadFailed": "Companies didn't load."
    },
    "company": {
      "notFoundTitle": "Company not found",
      "notFoundBody": "It may have been deleted, or the link points to another team.",
      "backToList": "Back to companies",
      "editLatest": "Edit",
      "inactive": "Inactive",
      "deleteLatest": "Delete latest record",
      "deleteLatestBody": "This deletes the latest record. The company then shows its previous record, or leaves the list if this was its only one.",
      "deleteFailed": "The record wasn't deleted."
    },
    "companyForm": {
      "createTitle": "New company",
      "createSubtitle": "Adds the company with its first record.",
      "editTitle": "Edit record",
      "duplicateTitle": "Add a record",
      "backToCompany": "Back to company",
      "duplicateInfo": "A new record keeps this company's history: it starts from the latest values and is dated now. Change what's different, then add it.",
      "generalHint": "The CRM ID ties every record of a company together.",
      "statusSection": "Status and revenue",
      "statusHint": "Lead status is required for leads.",
      "leadStatusRequired": "Required while the status is Lead.",
      "recordSection": "Record",
      "recordHint": "When this record took effect.",
      "active": "Active company",
      "choose": "Choose…",
      "fixErrors_one": "Fix the highlighted field to continue.",
      "fixErrors_other": "Fix the {{count}} highlighted fields to continue.",
      "create": "Create company",
      "saveChanges": "Save changes",
      "addRecord": "Add record",
      "recordAdded": "Record added",
      "minLength": "Use at least {{count}} characters"
    },
    "history": {
      "subtitle": "Every record of this company, newest first.",
      "viewLabel": "History view",
      "compact": "Changes",
      "full": "All fields",
      "spreadsheet": "Spreadsheet",
      "none": "No records yet.",
      "created": "Company created.",
      "noChanges": "Nothing changed in this record.",
      "empty": "(empty)",
      "changedTo": "changed to",
      "date": "Date",
      "source": "Source",
      "editRecord": "Edit record",
      "deleteRecord": "Delete record",
      "editTitle": "Edit {{field}}",
      "editDescription": "Change this value on this record.",
      "value": "Value",
      "allNewer": "Also change every newer record",
      "allNewerHint": "Newer records of this company get the same value.",
      "save": "Save value",
      "unchanged": "Value unchanged",
      "updated": "Value saved",
      "updatedAll": "Value saved on this and every newer record",
      "updateFailed": "Value wasn't saved. Try again.",
      "loadFailed": "The history didn't load."
    },
    "import": {
      "subtitle": "Add or update companies from an Excel sheet. Rows match on CRM ID.",
      "drop": "Drop an Excel file here, or choose one",
      "dropHint": ".xlsx or .xls, up to 10 MB. Columns as in the template.",
      "modified": "modified {{date}}",
      "processing": "Processing rows…",
      "summary": "{{ok}} imported, {{failed}} with errors, in {{seconds}} s",
      "another": "Import another file"
    },
    "pagination": {
      "label": "Pages",
      "range": "{{from}}–{{to}} of {{total}}",
      "perPage": "Per page",
      "previous": "Previous page",
      "next": "Next page",
      "page": "Page {{page}}"
    },
    "feed": {
      "title": "Activity",
      "subtitle": "What changed across your companies, newest first.",
      "today": "Today",
      "yesterday": "Yesterday",
      "emptyTitle": "No activity yet",
      "emptyBody": "New customers, upsells and churn show up here as they happen.",
      "end": "That's everything.",
      "owner": "Owner: {{name}}",
      "salesRep": "Sales rep: {{name}}",
      "events": {
        "newCustomer": "<b>{{name}}</b> became a customer.",
        "upsell": "<b>{{name}}</b> upgraded. MRR up {{amount}}.",
        "downgrade": "<b>{{name}}</b> downgraded. MRR down {{amount}}.",
        "churn": "<b>{{name}}</b> churned.",
        "newLead": "<b>{{name}}</b> is a new lead.",
        "lostLead": "<b>{{name}}</b> is a lost lead.",
        "dataChange": "<b>{{name}}</b> was updated.",
        "other": "<b>{{name}}</b> had an event."
      }
    },
    "subscription": {
      "title": "Subscription",
      "subtitle": "Your plan, what it includes and how much of it you use.",
      "currentPlan": "Current plan",
      "free": "Free",
      "premium": "Premium",
      "active": "Active",
      "ending": "Ending",
      "perMonth": "per month",
      "perYear": "per year",
      "renewsOn": "Renews on {{date}}.",
      "endsOn": "Ends on {{date}}; you keep Premium until then.",
      "openSourceBody": "Every feature, with no limits.",
      "granted": "Provided with your account.",
      "grantedUntil": "Provided with your account until {{date}}.",
      "freeBody": "The basics to get started. Upgrade for CRM integrations, custom fields and higher limits.",
      "upgrade": "Upgrade to Premium",
      "manageBilling": "Manage billing",
      "cancel": "Cancel plan",
      "cancelTitle": "Cancel Premium?",
      "cancelBody": "Premium stays active until {{date}}, then the team moves to Free.",
      "cancelled": "Premium ends on {{date}}",
      "cancelFailed": "The plan wasn't cancelled. Try again.",
      "resume": "Keep Premium",
      "resumeTitle": "Keep Premium?",
      "resumeBody": "The plan will renew on {{date}} as usual.",
      "resumed": "Premium will renew",
      "resumeFailed": "The plan wasn't resumed. Try again.",
      "portalFailed": "Billing didn't open. Try again.",
      "loadFailed": "Couldn't load the subscription. Reload the page to try again.",
      "notIncluded": "not included",
      "usage": "Usage",
      "usageHint": "Against your plan's limits.",
      "members": "Team members",
      "notInPlan": "Not in your plan",
      "limitReached": "Limit reached",
      "nearLimit": "Nearly full",
      "chooseTitle": "Choose a plan",
      "chooseBody": "Change or cancel any time from this page.",
      "monthly": "Monthly",
      "yearly": "Yearly, save {{saving}}%",
      "freeNote": "For trying Metafor out.",
      "premiumNote": "Everything, with room to grow.",
      "yearlyNote": "Billed once a year, {{saving}}% less than monthly.",
      "stripeNote": "Payment is handled by Stripe.",
      "continueToPayment": "Continue to payment",
      "checkoutFailed": "Checkout didn't open. Try again.",
      "features": {
        "addCompanies": "Add companies",
        "editCompanies": "Edit companies",
        "importXls": "Excel import",
        "cityView": "City View",
        "hubspot": "HubSpot integration",
        "zapier": "Zapier integration",
        "customFields": "Custom fields"
      }
    },
    "payment": {
      "successTitle": "You're on Premium",
      "successBody": "Integrations, custom fields and the higher limits are on now. The plan and invoices are on the subscription page.",
      "errorTitle": "Payment didn't go through",
      "errorBody": "Nothing was charged and your plan didn't change. This usually means the card was declined or expired. Try again, or use another card.",
      "tryAgain": "Try again",
      "viewSubscription": "View subscription"
    },
    "hub": {
      "team": {
        "title": "Team",
        "body": "Name, date format, currency and members."
      },
      "subscription": {
        "title": "Subscription",
        "body": "Plan, usage and billing."
      },
      "crm": {
        "title": "CRM integrations",
        "body": "Connect HubSpot and Zapier."
      },
      "customFields": {
        "title": "Custom fields",
        "body": "Extra fields on every company."
      },
      "mcp": {
        "title": "MCP access",
        "body": "Keys for AI assistants and scripts."
      },
      "ai": {
        "title": "AI model",
        "body": "Built-in agent or your own Gemini key."
      },
      "slack": {
        "title": "Slack",
        "body": "Weekly and monthly wraps in your channels."
      }
    },
    "crm": {
      "subtitle": "Bring companies in from your CRM and automation tools.",
      "hubspot": "Sync companies, statuses and custom fields from HubSpot.",
      "zapier": "Create and update companies from thousands of apps.",
      "connected": "Connected",
      "notConnected": "Not connected",
      "premiumOnly": "Integrations are part of Premium."
    },
    "hubspot": {
      "subtitle": "Companies sync from HubSpot on a schedule and when you ask.",
      "loadFailed": "Couldn't load the HubSpot connection. Reload the page to try again.",
      "notConnected": "Not connected",
      "notConnectedBody": "Connect a HubSpot account to bring its companies into Metafor. You'll approve access in HubSpot, then come back here to map fields.",
      "connect": "Connect HubSpot",
      "afterConnect": "Approve access in HubSpot, then come back to this tab; the connection shows up here by itself.",
      "preview": {
        "overview": {
          "title": "See what synced",
          "body": "A count of synced companies, broken down by status."
        },
        "fields": {
          "title": "Map fields",
          "body": "Choose which HubSpot properties fill MRR, owner and your custom fields."
        },
        "statuses": {
          "title": "Map statuses",
          "body": "Decide which HubSpot values make a company a lead, customer and so on."
        },
        "sync": {
          "title": "Set the range",
          "body": "Pick how far back history goes and whether new companies are created."
        }
      },
      "connectedTo": "Connected to {{domain}}",
      "lastSync": "Last sync",
      "syncStatus": "Status",
      "never": "Never",
      "sync": {
        "success": "Succeeded",
        "error": "Failed",
        "in_progress": "Running",
        "not_started": "Not run yet"
      },
      "syncNow": "Sync now",
      "syncing": "Syncing…",
      "syncStarted": "Sync started. You'll get a notification when it's done.",
      "syncRunning": "A sync is already running. Wait for it to finish.",
      "syncFailed": "Sync didn't start. Try again later.",
      "overviewTitle": "Synced companies",
      "overviewHint": "Companies that came from HubSpot, by their status now.",
      "overviewFailed": "Couldn't load the synced companies.",
      "companiesSynced": "Companies synced",
      "wipeAction": "Delete synced companies",
      "wipeTitle": "Delete synced companies?",
      "wipeBody": "All {{count}} companies that came from HubSpot, and their history, are deleted. The connection stays; the next sync brings them back.",
      "wiped": "Synced companies deleted",
      "wipeFailed": "Synced companies weren't deleted. Try again.",
      "fieldsTitle": "Field mapping",
      "fieldsHint": "Which HubSpot property fills each Metafor field. Name, status and CRM ID are always synced.",
      "fieldsFailed": "Couldn't load HubSpot properties. Reconnecting HubSpot usually fixes this.",
      "fields": {
        "mrr": "MRR",
        "mrrHint": "Numbers like 7276, 7.276,00 SEK or 7,2 kSEK are understood.",
        "csmId": "CSM ID",
        "orgno": "Organization number",
        "owner": "Owner",
        "ownerHint": "By default the HubSpot company owner is used.",
        "salesRep": "Sales rep",
        "activityLevel": "Activity level"
      },
      "notMapped": "Not mapped",
      "noOverride": "HubSpot company owner",
      "noCustomFields": "This team has no custom fields yet.",
      "searchFields": "Search properties…",
      "noFields": "No property matches.",
      "statusesTitle": "Status mapping",
      "statusesHint": "One HubSpot property decides each company's Metafor status.",
      "statusField": "HubSpot status property",
      "chooseStatusField": "Choose a property",
      "statusFieldHint": "Only properties with a fixed list of values are shown.",
      "statusesToSync": "Sync only companies with these values",
      "statusesToSyncHint": "Companies with any other value are left out of the sync.",
      "becomes": "Becomes {{status}}",
      "chooseValues": "Choose values",
      "searchValues": "Search values…",
      "noValues": "No value matches.",
      "selectAll": "Select all",
      "deselectAll": "Clear all",
      "selectedCount_one": "{{count}} value",
      "selectedCount_other": "{{count}} values",
      "removeValue": "Remove {{value}}",
      "syncTitle": "Sync",
      "syncHint": "How much history comes over and what gets created.",
      "historyFrom": "Import history from",
      "historyFromHint": "Records from this date on (inclusive) are imported. Leave empty for all history.",
      "onlyExisting": "Only update companies already in Metafor",
      "onlyExistingHint": "New HubSpot companies aren't created while this is on.",
      "unsaved": "You have unsaved changes.",
      "discard": "Discard",
      "save": "Save settings",
      "saved": "HubSpot settings saved",
      "saveFailed": "HubSpot settings weren't saved. Try again.",
      "disconnect": "Disconnect",
      "disconnectTitle": "Disconnect HubSpot?",
      "disconnectBody": "Syncing stops. Companies already synced stay in Metafor.",
      "removeAll": "Disconnect and delete data",
      "removeAllTitle": "Disconnect and delete HubSpot data?",
      "removeAllBody": "Syncing stops and every company that came from HubSpot is deleted, with its history.",
      "disconnected": "HubSpot disconnected",
      "removedAll": "HubSpot disconnected and its data deleted",
      "disconnectFailed": "HubSpot wasn't disconnected. Try again."
    },
    "zapier": {
      "subtitle": "Zapier connects Metafor to thousands of apps with a secret key.",
      "open": "Open Zapier",
      "keyTitle": "API key",
      "keyHint": "Zapier uses this key to act on this team. Keep it secret.",
      "noKey": "No key yet. Create one, then paste it into Zapier.",
      "create": "Create API key",
      "created": "API key created",
      "createFailed": "API key wasn't created. Try again.",
      "show": "Show key",
      "hide": "Hide key",
      "copy": "Copy key",
      "copied": "Key copied",
      "copyFailed": "Couldn't copy. Select the key and copy it by hand.",
      "rotate": "Replace key",
      "rotateTitle": "Replace the API key?",
      "rotateBody": "The current key stops working at once. Zaps using it need the new key.",
      "rotated": "New API key created; the old one no longer works",
      "remove": "Delete key",
      "removeTitle": "Delete the API key?",
      "removeBody": "Zaps using this key stop working.",
      "removed": "API key deleted",
      "removeFailed": "API key wasn't deleted. Try again.",
      "howTitle": "Set up",
      "steps": {
        "one": {
          "title": "Create a key",
          "body": "It proves to Metafor that requests from Zapier are yours."
        },
        "two": {
          "title": "Add Metafor in Zapier",
          "body": "Paste the key when Zapier asks for your Metafor credentials."
        },
        "three": {
          "title": "Build a Zap",
          "body": "Create or update companies whenever something happens in another app."
        }
      }
    },
    "slack": {
      "subtitle": "Your city's wraps, posted to Slack every Monday.",
      "loadFailed": "Slack settings didn't load. Reload the page.",
      "notConfigured": "Slack isn't set up on this server yet.",
      "premiumOnly": "Slack wraps are part of Premium.",
      "notConnected": "Not connected",
      "notConnectedBody": "Connect your Slack workspace, then invite @Metafor to the channels that should get the wraps.",
      "connect": "Add to Slack",
      "connectedToast": "Slack connected. Now invite @Metafor to a channel.",
      "installExpired": "The Slack link expired. Try again.",
      "installFailed": "Slack wasn't connected. Try again.",
      "steps": {
        "connect": {
          "title": "Add to Slack",
          "body": "Allow Metafor in your workspace."
        },
        "invite": {
          "title": "Invite the bot",
          "body": "Type /invite @Metafor in any channel, public or private."
        },
        "pick": {
          "title": "Pick the wraps",
          "body": "Weekly, monthly, quarterly or yearly, per channel."
        }
      },
      "workspace": "Workspace",
      "workspaceHint": "The Slack workspace the bot posts in.",
      "timezone": "Time zone",
      "timezoneHint": "Wraps go out on Monday from 9:00 in this time zone.",
      "timezoneSaved": "Time zone saved",
      "saveFailed": "Not saved. Try again.",
      "disconnect": "Disconnect Slack",
      "disconnectTitle": "Disconnect Slack?",
      "disconnectBody": "The bot stops posting and leaves your workspace. Every channel's settings are removed.",
      "disconnected": "Slack disconnected",
      "disconnectFailed": "Slack wasn't disconnected. Try again.",
      "channels": "Channels",
      "channelsHint": "Channels the bot is in, and the wraps each one gets. People in the channel can change this with /metafor too.",
      "noChannels": "The bot isn't in any channel yet. In Slack, open the channel that should get the wraps and type:",
      "copyInvite": "Copy the command",
      "inviteCopied": "Command copied",
      "copyFailed": "Couldn't copy. Select the command and copy it by hand.",
      "waiting": "Waiting for the bot to join a channel…",
      "private": "Private channel",
      "periods": {
        "week": "Weekly",
        "month": "Monthly",
        "quarter": "Quarterly",
        "year": "Yearly"
      },
      "kinds": {
        "week": "weekly",
        "month": "monthly",
        "quarter": "quarterly",
        "year": "yearly"
      },
      "next": "Next: {{date}}, the {{kind}} wrap of {{name}}",
      "nothing": "Nothing is posted here. Tick a wrap to start.",
      "paused": "Paused until the team is on Premium again.",
      "postNow": "Post latest now",
      "posted": "Posted the {{kind}} wrap of {{name}} to #{{channel}}",
      "postFailed": "The wrap wasn't posted. Try again.",
      "lastPost": "Last posted {{date}}",
      "errors": {
        "channel": "The bot can't post here any more. Invite it to the channel again.",
        "revoked": "Slack access was revoked. Disconnect and connect Slack again.",
        "other": "The last post failed ({{code}})."
      },
      "scheduleTitle": "Every Monday",
      "scheduleHint": "Each channel gets the biggest wrap that has just closed, among those it takes.",
      "schedule": {
        "year": {
          "when": "First Monday of a year",
          "what": "Last year"
        },
        "quarter": {
          "when": "First Monday of a quarter",
          "what": "Last quarter"
        },
        "month": {
          "when": "First Monday of a month",
          "what": "Last month"
        },
        "week": {
          "when": "Any other Monday",
          "what": "Last week, Monday to Sunday"
        }
      }
    },
    "customFields": {
      "title": "Custom fields",
      "subtitle": "Extra fields every company can have. They appear in the company form, the history and the HubSpot field mapping.",
      "newLabel": "New field",
      "placeholder": "e.g. Region or Contract length",
      "add": "Add field",
      "added": "Field “{{name}}” added",
      "duplicate": "A field with this name already exists.",
      "saveFailed": "Field wasn't saved. Try again.",
      "loadFailed": "Custom fields didn't load. Refresh the page to try again.",
      "emptyTitle": "No custom fields yet",
      "emptyBody": "Add a field above to track something the standard fields don't cover.",
      "addedOn": "Added {{date}}",
      "rename": "Rename",
      "renameNamed": "Rename {{name}}",
      "renamed": "Field renamed to “{{name}}”",
      "delete": "Delete field",
      "deleteNamed": "Delete {{name}}",
      "deleteTitle": "Delete “{{name}}”?",
      "deleteBody": "Its values are removed from every company. This can't be undone.",
      "deleted": "Field “{{name}}” deleted",
      "deleteFailed": "Field wasn't deleted. Try again.",
      "footnote": "Renaming a field keeps its values. Deleting it removes them."
    },
    "alerts": {
      "title": "Alerts",
      "subtitle": "Bubbles over the buildings in your city that need a look. Each alert has one trigger; a building shows the first alert it matches, in this order.",
      "upsellTitle": "Choose and tune all 20 alerts with Premium",
      "upsellBody": "Your plan includes two alerts with fixed triggers. Premium lets you switch on any alert and decide what triggers it, including your custom fields.",
      "upgrade": "See Premium",
      "premium": "Premium",
      "includedInFree": "Included in Free",
      "loadFailed": "Couldn't load the alerts.",
      "saveFailed": "Couldn't save the alert.",
      "saved": "{{name}} saved",
      "restored": "{{name}} is back to its default",
      "switchedOn": "{{name}} is on",
      "switchedOff": "{{name}} is off",
      "toggleNamed": "Show {{name}}",
      "chooseFieldFirst": "Choose a field first",
      "chooseField": "Choose a field",
      "loadingFields": "Loading fields…",
      "searchFields": "Search fields…",
      "noFields": "No field matches.",
      "calculated": "calculated",
      "customField": "custom field",
      "operator": "Comparison",
      "value": "Value",
      "chooseValue": "Choose a value",
      "restore": "Back to default",
      "restoreNamed": "Put {{name}} back to its default",
      "missingField": "This field no longer exists. Choose another one.",
      "customFieldsUnavailable": "Custom fields can't be loaded right now, so only the built-in fields are offered. Alerts already set on custom fields keep working.",
      "customFieldUnavailable": "This alert uses a custom field that can't be loaded right now.",
      "noTrigger": "No trigger",
      "footnote": "Calculated fields are worked out by the city from each company’s history, as of the date on the timeline.",
      "items": {
        "crisis": {
          "label": "Crisis",
          "hint": "A big drop that needs action now"
        },
        "urgent": {
          "label": "Urgent",
          "hint": "Something to handle today"
        },
        "attention": {
          "label": "Needs attention",
          "hint": "Worth a look soon"
        },
        "blocked": {
          "label": "Blocked",
          "hint": "Stuck on something outside your hands"
        },
        "declining": {
          "label": "MRR declining",
          "hint": "Revenue from this customer is going down"
        },
        "unhappy": {
          "label": "Unhappy",
          "hint": "The customer is not satisfied"
        },
        "needs-input": {
          "label": "Needs input",
          "hint": "Waiting on an answer from you"
        },
        "person-needed": {
          "label": "Person needed",
          "hint": "No one is looking after it"
        },
        "maintenance": {
          "label": "Maintenance",
          "hint": "Due for a check-up"
        },
        "idle": {
          "label": "Deal asleep",
          "hint": "A lead or opportunity that has stopped moving"
        },
        "delivery": {
          "label": "Delivery",
          "hint": "Something to deliver or onboard"
        },
        "in-progress": {
          "label": "In progress",
          "hint": "Work under way"
        },
        "conversation": {
          "label": "Conversation",
          "hint": "An open conversation"
        },
        "opportunity": {
          "label": "New opportunity",
          "hint": "A deal that just opened"
        },
        "money-event": {
          "label": "Big account",
          "hint": "A large contract"
        },
        "high-activity": {
          "label": "High activity",
          "hint": "A lot is happening"
        },
        "improving": {
          "label": "MRR growing",
          "hint": "Revenue from this customer is going up"
        },
        "completed": {
          "label": "New customer",
          "hint": "Just won"
        },
        "happy": {
          "label": "Happy",
          "hint": "The customer is satisfied"
        },
        "notable-event": {
          "label": "Top customer",
          "hint": "Among your biggest accounts"
        }
      }
    },
    "mcp": {
      "title": "MCP access",
      "subtitle": "Let an AI assistant such as Claude or Cursor read and update this team's companies over MCP.",
      "endpoint": "Endpoint",
      "endpointHint": "The address your MCP client connects to.",
      "copyEndpoint": "Copy endpoint",
      "endpointCopied": "Endpoint copied",
      "keys": "Keys",
      "keysHint": "A key acts as the person who created it, with their role. Revoke keys you no longer use.",
      "noKeys": "No keys yet. Generate one for each assistant or device you connect.",
      "loadFailed": "Keys didn't load. Refresh the page to try again.",
      "unnamed": "Unnamed key",
      "createdOn": "Created {{date}}",
      "createdBy": "Created {{date}} by {{name}}",
      "generate": "Generate key",
      "generateTitle": "Generate an MCP key",
      "generateBody": "Name the key after where you'll use it, so you can tell keys apart later.",
      "nameLabel": "Name (optional)",
      "namePlaceholder": "e.g. Claude on my laptop",
      "generateFailed": "Key wasn't generated. Try again.",
      "revealTitle": "Your new MCP key",
      "revealBody": "Add it to your MCP client with one of the setups below.",
      "keyLabel": "MCP key",
      "onlyOnce": "Copy the key now. It isn't shown again; if you lose it, revoke it and generate a new one.",
      "copyKey": "Copy key",
      "keyCopied": "Key copied",
      "done": "I've copied the key",
      "copyFailed": "Couldn't copy. Select the text and copy it by hand.",
      "revoke": "Revoke",
      "revokeTitle": "Revoke “{{name}}”?",
      "revokeBody": "Any assistant using this key loses access at once. This can't be undone.",
      "revoked": "Key “{{name}}” revoked",
      "revokeFailed": "Key wasn't revoked. Try again.",
      "connect": "Connect a client",
      "connectHint": "Replace <your key> with a key from above.",
      "client": "MCP client",
      "jsonConfig": "JSON config",
      "otherClients": "Other clients",
      "copySnippet": "Copy setup",
      "snippetCopied": "Setup copied",
      "clientHint": {
        "claude": "Run this in a terminal.",
        "json": "For Cursor and other clients that read an mcpServers file, such as .cursor/mcp.json.",
        "other": "Add a remote (Streamable HTTP) server with this URL and header."
      }
    },
    "ai": {
      "title": "AI model",
      "subtitle": "The model behind the assistant here and the agent in your 3D city.",
      "upsellTitle": "Use your own Gemini key",
      "upsellBody": "On Premium, the assistant and the city's agent can run on your team's own Gemini API key: your quota, your model.",
      "loadFailed": "Could not load the AI settings.",
      "source": "Model",
      "sourceHint": "Both agents use the same choice.",
      "builtin": "Built-in agent",
      "builtinBody": "Metafor's Gemini. Nothing to set up.",
      "builtinMissing": "Not available on this server right now.",
      "own": "Your own Gemini key",
      "ownBody": "The agents call Gemini with your key. If the key stops working, they show an error instead of switching to ours.",
      "key": "Gemini API key",
      "keyHint": "Stored encrypted and never shown again. It is checked with a short request before it is saved.",
      "getKey": "Get a key in Google AI Studio",
      "keyLabel": "API key",
      "replaceKey": "Replace with a new key",
      "model": "Model (optional)",
      "modelPlaceholder": "Automatic",
      "modelHint": "A Gemini model id, such as gemini-flash-latest. Leave empty and Metafor picks one that answers.",
      "notConfigured": "The server cannot store keys yet. Ask Metafor support to enable it.",
      "verified": "Worked {{date}} on {{model}}",
      "test": "Test",
      "testOk": "The key works.",
      "testFailed": "The key did not work.",
      "remove": "Remove",
      "removeTitle": "Remove your Gemini key?",
      "removeBody": "The agents go back to the built-in model. You can add a key again at any time.",
      "removed": "Key removed. The agents use the built-in model.",
      "removeFailed": "Could not remove the key.",
      "checking": "Checking the key…",
      "savedOwn": "Saved. The agents now use your Gemini key.",
      "savedBuiltin": "Saved. The agents use the built-in model.",
      "saveFailed": "Could not save the AI settings."
    },
    "profile": {
      "title": "Profile",
      "subtitle": "Your name, sign-in and how Metafor looks for you.",
      "details": "Your details",
      "detailsHint": "Teammates see your name in the member list and in company history.",
      "inTeam": "in {{team}}",
      "name": "Name",
      "nameMin": "Use at least 2 characters",
      "nameSaved": "Name saved",
      "nameFailed": "Name wasn't saved. Try again.",
      "email": "Email",
      "verified": "Verified",
      "notVerified": "Not verified",
      "viaGoogle": "You sign in with Google.",
      "viaPassword": "You sign in with email and password.",
      "sendVerification": "Send verification email",
      "verificationSent": "Verification email sent to {{email}}",
      "verificationFailed": "Verification email wasn't sent. Try again in a minute.",
      "password": "Password",
      "passwordHint": "Use at least 8 characters. You stay signed in on this device.",
      "currentPassword": "Current password",
      "currentRequired": "Enter your current password",
      "samePassword": "Choose a password different from the current one",
      "changePassword": "Change password",
      "passwordChanged": "Password changed",
      "wrongPassword": "That isn't your current password.",
      "weakPassword": "Choose a stronger password.",
      "tooManyAttempts": "Too many attempts. Wait a few minutes and try again.",
      "passwordFailed": "Password wasn't changed. Try again.",
      "googlePassword": "You sign in with Google, so there's no Metafor password to change. Manage it in your Google account.",
      "noPassword": "Your account has no password to change.",
      "openGoogle": "Open Google account",
      "preferences": "Preferences",
      "preferencesHint": "Saved on this device."
    },
    "assistant": {
      "title": "Assistant",
      "subtitle": "Ask about your companies, or have it make changes you approve.",
      "ask": "Ask assistant",
      "openFull": "Open full page",
      "newChat": "New chat",
      "newChatTitle": "Start a new chat?",
      "newChatBody": "This conversation is deleted. The assistant won't remember it.",
      "resetFailed": "The chat wasn't cleared. Try again.",
      "loadFailed": "The conversation didn't load.",
      "retry": "Try again",
      "you": "You",
      "thinking": "Thinking",
      "replyFailed": "The reply didn't come through. Send your message again.",
      "emptyTitle": "What can I help with?",
      "emptyBody": "I can look up companies and numbers, and make changes such as creating a company or inviting a teammate. You approve every change before it happens.",
      "suggest": {
        "lookUp": "Look something up",
        "change": "Make a change",
        "topCustomers": "Which customers have the highest MRR?",
        "newLeads": "Show our open leads",
        "dashboard": "Summarize the dashboard",
        "createCompany": "Create a company called Acme Corp",
        "invite": "Invite john@example.com to the team as an admin",
        "renameTeam": "Rename the team to Acme Sales"
      },
      "placeholder": "Ask anything about your companies",
      "answerFirst": "Approve or decline the action above to continue",
      "send": "Send",
      "stop": "Stop",
      "footnote": "The assistant can be wrong. Check changes before you approve them.",
      "approve": "Approve",
      "decline": "Decline",
      "nothingYet": "Nothing changes until you approve.",
      "openCompany": "Open company",
      "gone": "This action is no longer waiting for an answer.",
      "executeFailed": "The action didn't run. Check your connection and try again.",
      "lookupFailed": "Couldn't finish: {{what}}",
      "andMore": "and {{count}} more",
      "status": {
        "pending": "Needs approval",
        "running": "Running",
        "completed": "Done",
        "failed": "Failed",
        "denied": "Declined"
      },
      "fields": {
        "email": "Email",
        "role": "Role",
        "newName": "New name",
        "name": "Name",
        "status": "Status",
        "mrr": "MRR",
        "crmId": "CRM ID",
        "companies_one": "{{count}} company",
        "companies_other": "{{count}} companies"
      },
      "tools": {
        "list_companies": {
          "read": "Looked through companies"
        },
        "get_company": {
          "read": "Opened a company"
        },
        "company_history": {
          "read": "Read a company's history"
        },
        "dashboard_stats": {
          "read": "Checked the dashboard"
        },
        "find_settings": {
          "read": "Looked up where a setting is"
        },
        "create_company": {
          "title": "Create a company"
        },
        "upsert_companies": {
          "title": "Create or update companies"
        },
        "invite_user": {
          "title": "Invite a teammate"
        },
        "rename_team": {
          "title": "Rename the team"
        }
      },
      "done": {
        "createCompany": "Created {{name}}",
        "upsertCompanies": "{{created}} created, {{updated}} updated, {{failed}} failed"
      }
    },
    "common": {
      "retry": "Try again"
    },
    "footer": {
      "label": "Footer",
      "support": "Support",
      "privacy": "Privacy"
    },
    "limits": {
      "title": "Plan limit reached",
      "upgrade": "Upgrade",
      "companies_one": "Your plan allows {{count}} company. Upgrade to add more.",
      "companies_other": "Your plan allows {{count}} companies. Upgrade to add more.",
      "users_one": "Your plan allows {{count}} member. Upgrade to invite more.",
      "users_other": "Your plan allows {{count}} members. Upgrade to invite more.",
      "integrations_zero": "Your plan doesn't include integrations. Upgrade to connect one.",
      "integrations_one": "Your plan allows {{count}} integration. Upgrade to connect more.",
      "integrations_other": "Your plan allows {{count}} integrations. Upgrade to connect more.",
      "hubspotRefused": "HubSpot wasn't connected: your plan has no room for another integration.",
      "hubspotFailed": "HubSpot couldn't be connected. Please try again.",
      "importRefused": "Nothing was imported: the companies limit is reached.",
      "skipped_one": "{{count}} company from your CRM was not imported",
      "skipped_other": "{{count}} companies from your CRM were not imported"
    },
    "trial": {
      "planName": "Premium trial",
      "badge": "Trial",
      "body": "Every Premium feature until {{date}}. After that the team moves to Free, unless you choose a plan.",
      "endsOn": "Your Premium trial ends on {{date}}.",
      "daysLeft_one": "{{count}} day left.",
      "daysLeft_other": "{{count}} days left.",
      "ended": "Your Premium trial has ended.",
      "endedBody": "The team is on Free now. Your data is all here; choose a plan to get HubSpot, Zapier and the higher limits back.",
      "choosePlan": "Choose a plan",
      "close": "Close"
    }
  }
}
